export enum Locales {
  ru = 'ru',
  kk = 'kk',
  en = 'en',
}

export enum DeviceTypes {
  IOS = 'ios',
  ANDROID = 'android',
  OTHER = 'other',
}

export const DEFAULT_LOCALE = 'ru';
